export const MPO_RECOMMENDED_PLAN_ID = 1;
export const PLAN_NAME_MAX_LENGTH = 30;
export const MPO_SUPPORT_URL =
  'https://support.measured.com/article/dgtiuodr5t-media-plan-optimizer-using-mpo-alpha-concepts';
export const MPO_PLAN_SETTINGS_SUPPORT_URL =
  'https://support.measured.com/article/dgtiuodr5t-media-plan-optimizer-using-mpo-alpha-concepts#plan_settings';
export const DEFAULT_OPTIMIZE_FOR_DAYS = 30;
export const MIN_OPTIMIZE_FOR_DAYS = 1;
export const MAX_OPTIMIZE_FOR_DAYS = 180;

// MPO Field and Dimension Constants
export enum MPOFieldNames {
  tactic = 'tactic',
  channel = 'channel',
  budget = 'budget',
  budgetAdjustment = 'budgetAdjustment',
  returnCurve = 'returnCurve',
  salesINetGain = 'salesINetGain',
  segment = 'segment'
}

export enum MPOModalTypes {
  tactic = 'tactic',
  channel = 'channel'
}

export enum MPOQueryStatuses {
  success = 'success',
  error = 'error',
  pending = 'pending'
}

export enum MPOOptimizationTypes {
  custom = 'custom'
}

export enum MPOFilterNames {
  relativeDate = 'relativeDate',
  day = 'day'
}

export enum MPOKeys {
  Escape = 'Escape',
  Enter = 'Enter'
}

export enum MPOClasses {
  budgetAdjustmentBudgetColumn = 'budget-adjustment-budget-column'
}

// Chart Constants
export enum MPOChartLabels {
  mediaSpend = 'Media Spend',
  incrementalSales = 'Incremental Sales',
  incrementalOrders = 'Incremental Orders',
  roas = 'ROAS',
  cpo = 'CPO'
}

export enum MPOChartTypes {
  spline = 'spline',
  scatter = 'scatter',
  line = 'line'
}
